<script>
import MainLayout from '@/layouts/MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import Chevron from '@/components/shared/Chevron';
import api from '../../api/analytics/index';


export default {
  name: 'AnalyticsList',
  components: {
    MainLayout,
    GridRow,
    GridCol,
    Chevron
  },
  data() {
    return {
      analytics: [],
      breadcrumb: [
        {link: '/workspace', name: 'Workspace'},
        {link: '', name: 'Listado de Analíticas', disabled: true}
      ]
    };
  },
  created() {
    this.fetchAnalytics();
  },
  methods: {
    fetchAnalytics() {
      api.getAnalytics(this)
        .then(response => {
          this.analytics = response;
        })
        .catch(error => {
          console.error("Error fetching analytics", error);
        });
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString();
    },
    goToCategories(id) {
      this.$router.push({
        name: 'ListOfCategories',
        params: { analyticId: id }
      });
    }
  }
};
</script>

<template>
  <main-layout controlsBg="light" :hasControlsBar="false" :breadcrumb="breadcrumb">
    <div class="container">
      <grid-row class="margin-top-xl" column-align="center">
        <grid-col col-size="8">
          <div id="header">
            <h1 class="header-title">
              <chevron @click="$router.push({name: 'Workspace'})"/>
              Historial de Analíticas
            </h1>
          </div>
        </grid-col>
      </grid-row>

      <grid-row class="margin-top-xl" column-align="center">
        <grid-col col-size="8">
          <div class="analytics-list">
            <table class="analytics-table">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Notas / Detalles</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="analytic in analytics" :key="analytic.id" @click="goToCategories(analytic.id)" class="clickable-row">
                  <td>{{ formatDate(analytic.analysisAt) }}</td>
                  <td>{{ analytic.notes || 'Sin notas' }}</td>
                  <td class="icon-cell"><chevron right /></td>
                </tr>
              </tbody>
            </table>
            <div v-if="analytics.length === 0" class="no-data">
              No hay analíticas disponibles.
            </div>
          </div>
        </grid-col>
      </grid-row>
    </div>
  </main-layout>
</template>

<style scoped lang="scss">
.analytics-list {
  background: #ffffff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.analytics-table {
  width: 100%;
  border-collapse: collapse;

  th, td {
    padding: 15px;
    text-align: left;
    border-bottom: 1px solid #f0f0f0;
  }

  th {
    background-color: #fafafa;
    color: #555;
    font-weight: bold;
  }

  .clickable-row {
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background-color: #f9f9f9;
    }
  }

  .icon-cell {
    text-align: right;
    color: #888;
    width: 40px;
  }
}

.no-data {
  text-align: center;
  padding: 20px;
  color: #888;
}
</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/analytics/AnalyticsList.vue